<div class="d-flex" [formGroup] [ngStyle]="{ 'flex-direction': isModalPlacement || isMobile ? 'column' : 'row' }">
  <!--  TODO: REMOVE [ngStyle] AFTER -->
  <div class="form-group" [ngStyle]="{ flex: isOldStyleTheme ? '1' : 'inherit', 'margin-right': isOldStyleTheme ? '10px' : '0px' }">
    <label>
      {{ "LABELS.BUSINESS_ID_NUMBER" | translate }}
    </label>

    <div class="btn-group btn-group-qual" [ngClass]="{ 'has-error': identifierQualifierControl.hasError('required') }">
      <ng-container *ngFor="let qual of identitiesQual; let i = index">
        <button
          type="button"
          class="btn btn-primary"
          (click)="setIdentitiesQual(qual)"
          [ngClass]="{ 'is-active': identifierQualifierControl.value === qual }"
          [disabled]="identifierQualifierControl.disabled || isDisabled"
        >
          {{ getIdentifierQualifierTranslationText(qual) | translate | uppercase }}
        </button>
      </ng-container>
    </div>
    <app-control-errors
      [control]="identifierQualifierControl"
      [errors]="errors"
      [isShowAlways]="true"
      [isShowHelper]="false"
    ></app-control-errors>
  </div>

  <p
    *ngIf="
      isHasAssignedCbpRequest &&
      isOtherIdentifierQualifierSelected &&
      !isAssignedCbpRequestSubmittedOrApproved &&
      !isAssignedCbpRequestRejected
    "
    class="cbp-assigned-description"
  >
    {{ "LABELS.APPLY_FOR_CBP_ASSIGNED_NUMBER" | translate }}
  </p>

  <div class="cbp-assigned-status-box" *ngIf="isShowAssignedCbpRequestSubmitted">
    <img src="/assets/icons/icon_circled_check_light_green.svg" alt="checkmark" />
    <span>
      {{ "LABELS.ASSIGNED_CBP_NUMBER_APPLICATION_SUBMITTED" | translate }}
    </span>
  </div>

  <!-- identifier -->
  <!--  TODO: REMOVE [ngStyle] - flex AFTER, LEAVE flex-direction -->
  <div
    *ngIf="(isHasAssignedCbpRequest && !isShowAssignedCbpRequestSubmitted) || !isHasAssignedCbpRequest"
    class="d-flex"
    [ngStyle]="{ 'flex-direction': isModalPlacement ? 'row' : 'column', flex: isOldStyleTheme ? '1' : 'inherit' }"
  >
    <div class="flex-shrink-1 flex-grow-1 mr-1">
      <app-identifier-hidden-control
        [isDisabled]="isDisabled"
        [hide]="hide"
        [control]="identifierControl"
        [errors]="errors"
        [helper]="helperIdentifier"
        [itemMask]="itemMask"
        [entityIdentifierQualifier]="identifierQualifierControl.value"
        [controlId]="controlId"
      ></app-identifier-hidden-control>
    </div>
    <div class="flex-shrink-1 flex-grow-1 form-group" *ngIf="isShowDateOfBirth">
      <label>{{ "LABELS.DATE_OF_BIRTH" | translate }}</label>
      <date-picker
        [fc]="dateOfBirthControl"
        [errors]="errors.dateOfBirth"
        [id]="'dateOfBirth'"
        [name]="'dateOfBirth'"
        [placeholder]="'FORM_PLACEHOLDER.DATEOFBIRTH'"
        [required]="true"
        [isShowDisabled]="dateOfBirthControl.disabled"
        [isWithIcon]="true"
      ></date-picker>
    </div>
  </div>
</div>
